export default "__VITE_ASSET__C5lCgdId__"